import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TextEditorComponent } from './text-editor.component';
import { NgxEditorModule } from 'ngx-editor';

@NgModule({
    declarations: [TextEditorComponent],
    imports: [CommonModule, FormsModule, NgxEditorModule],
    exports: [TextEditorComponent],
})
export class TextEditorModule {}
